import { createRouter, createWebHistory } from 'vue-router'
import { getToken, getTokenFromStorage } from '../utils/tool'
import Layout from '@/layout/index.vue';
import AppLayout from '../src/layout/home.vue'
import LayoutEmpyt from '../src/layout/empyt.vue'
import Index from '../src/pages/index.vue'
// import Order from '../src/pages/order/index.vue'
import Personal from '../src/pages/personal/index.vue'
import Login from '../src/pages/login.vue'
import Product from '../src/pages/product/index.vue'
import Kyc from '../src/pages/verify/kyc.vue'
import Face from '../src/pages/verify/active.vue'
import Base from '../src/pages/verify/base.vue'
import Work from '../src/pages/verify/work.vue'

import Contact from '../src/pages/verify/contact.vue'
// import Contact2 from '../src/pages/verify/contact2.vue'
import Callback from '../src/pages/verify/callback.vue'
import ProductDetail from '../src/pages/product/detail.vue'
import ProductDeny from '../src/pages/product/deny.vue'
import Bank from '../src/pages/bank/index.vue'
import bankAdd from '../src/pages/bank/add.vue'
import Ifsc from '../src/pages/bank/isfc.vue'

// import Schedule from '../src/pages/scheduled/index.vue'
import ScheduleDetail from '../src/pages/scheduled/detail.vue'

import Orders from '../src/pages/orders/index.vue'
import orderDetail from '../src/pages/orders/detail.vue'
import tryExtension from '../src/pages/orders/extension.vue'

import orderAudit from '../src/pages/orders/audit.vue'
import orderAudit2 from '../src/pages/orders/audit2.vue'
import orderConfirm from '../src/pages/orders/confirm.vue'
import Aboutus from '../src/pages/personal/about.vue'
import Help from '../src/pages/personal/help.vue'
import Download from '../src/pages/download.vue'
import Alert from '../src/pages/alert.vue'
import VerifyIndex from '../src/pages/verify/index.vue'
import FeedbackIndex from '../src/pages/feedback/index.vue'
import Test from '../src/pages/test.vue'
import Distribution from '../src/pages/distribute.vue'
import Privacy from '../src/pages/protocol/privacy.vue'
import Terms from '../src/pages/protocol/term.vue'
// import testNotification from '../src/pages/notification.vue'
import PromotionRegister from '../src/pages/promotion/register.vue'
import PromotionAmount from '../src/pages/promotion/amount.vue'
import ValidateIdCard from '../src/pages/verify/validateIdCard.vue'
const routes = [
    {
        path:'/',
        name: 'Index',
        component: AppLayout,
        children:[
            {
                path:'',
                name: 'Home',
                component: Index,
                meta:{ title:'Index', bgcolor:'#F7F7F7' }
            },            
            {
                path:'personal',
                name: 'Personal',
                component: Personal,
                meta:{ title:'Personal', bgcolor:'#fff' }
            },
            {
              path:'order',
              name: 'order',
              component: Orders,
              meta:{ title:'Orders', bgcolor:'#fff' }
            }
        ]        
    },
    {
      path:'/protocol/term',
      name: 'term',
      component: Terms,
      meta:{ title:'Terms', bgcolor:'#fff' }
    },
    {
      path:'/protocol/privacy',
      name: 'privacy',
      component: Privacy,
      meta:{ title:'Privacy', bgcolor:'#fff' }
    },
    {
      path:'/feedback',
      name: 'Feedback',
      component: Layout,
      meta:{ title:'FeedBack', bgcolor:'#fff' },
      children:[
          {
              path:'',
              name: 'feedback',
              component: FeedbackIndex,
              meta:{ title:'FeedBack', bgcolor:'#fff' }
          }
      ]
    },
    {
      path:'/schedule/:oid',
      name: 'schedule_detail',
      component: ScheduleDetail,
      meta:{ title:'Scheduled Orders', bgcolor:'#fff' }
    },
    {
      path: '/joint',
      name: 'joint',
      component: Test,
      meta:{ title:'PaceLoan', bgcolor:'#fff' }
    },
    
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta:{ title:'Login', bgcolor:'#fff' }
    },
    {
      path: '/promotion/',
      name:"Promotion",
      component: LayoutEmpyt,
      children:[
        {
          path:"register",
          name: "register",
          component: PromotionRegister,
          meta:{ title:'register', bgcolor:'#F7F7F7' }
        },
        {
          path:"amount",
          name: "amount",
          component: PromotionAmount,
          meta:{ title:'Congraluation', bgcolor:'#F7F7F7' }
        },
      ]
    },
    {
      path: '/auth',
      name:"Verify",
      component: Layout,
      children:[
        {
          path:"index",
          name: "VerifyIndex",
          component: VerifyIndex,
          meta:{ title:'Index', bgcolor:'#F7F7F7' }
        },
        {
          path:"face",
          name: "Face",
          component: Face,
          meta:{ title:'Face', bgcolor:'#F7F7F7' }
        },
        {
          path:"identity",
          name: "identity",
          component: Kyc,
          meta:{ title:'Kyc', bgcolor:'#F7F7F7' }
        },
        {
          path:"validateIdCard",
          name: "validateIdCard",
          component: ValidateIdCard,
          meta:{ title:'Kyc', bgcolor:'#FEF8EC' }
        },
        {
          path:"basic",
          name: "Base",
          component: Base,
          meta:{ title:'Base', bgcolor:'#fff' }
        },
        {
          path:"work",
          name: "work",
          component: Work,
          meta:{ title:'work Information', bgcolor:'#fff' }
        },
        {
          path:"contacts",
          name: "Contact",
          component: Contact,
          meta:{ title:'Contact', bgcolor:'#F7F7F7' }
        },        
        {
          path: "callback",
          name: "callback",
          component: Callback,
          meta:{ title:'Callback', bgcolor:'#fff' }
        }
      ]
    },
    {
      path:"/product",
      component:Layout,
      children:[
        {
          path: ':pid',
          name: 'Product',
          component: Product,
          meta:{ title:'Product', bgcolor:'#fff' }
        },    
        {
          path: ':pid/detail',
          name: 'Product-Detail',
          component: ProductDetail,
          meta:{ title:'Detail', bgcolor:'#fff' }
        }, 
        {
          path: ':pid/denied',
          name: 'Product-Denied',
          component: ProductDeny,
          meta:{ title:'Denied', bgcolor:'#fff' }
        },  
      ]
    },
      
    {
      path: '/bank',
      name: 'Bank',   
      component: Layout,   
      children:[
        {
          path:"",
          name: "Bank",
          component:Bank,
          meta:{ title:'Bank', bgcolor:'#fff' }
        },
        {
          path:"add",
          name: "Bank_Add",
          component: bankAdd,
          meta:{ title:'Bank', bgcolor:'#fff' }
        },
        {
          path:"ifsc",
          name: "IFSC",
          component: Ifsc,
          meta:{ title:'Bank', bgcolor:'#fff' }
        }         
      ]
    },  
    {
      path:"/orders/",
      name:'orders',
      component: Layout,
      meta:{ title:'Orders', bgcolor:'#F6F6F6'},
      children:[
        {
          path:"/orders/:id/extension",
          name:'Order_Extension',
          component: tryExtension,
          meta:{ title:'Extension', bgcolor:'#F6F6F6'}
        },
        {
          path:"/orders/:id/detail",
          name:'Order_Detail',
          component: orderDetail,
          meta:{ title:'Detail', bgcolor:'#fff'}
        },{
          path:"/orders/:id/audit",
          name:'Order_audit',
          component: orderAudit,
          meta:{ title:'Auditing', bgcolor:'#fff'}
        },{
          path:"/orders/audit",
          name:'Order_auditt',
          component: orderAudit2,
          meta:{ title:'Auditing', bgcolor:'#fff'}
        },{
          path:"/orders/:id/confirm",
          name:'Order_confirm',
          component: orderConfirm,
          meta:{ title:'Confirm', bgcolor:'#fff'}
        },
      ]
    },  
    
    {
      path: '/personal',
      name: 'personal',
      component:Layout,
      children:[
        {
          path:"aboutus",
          name:'aboutus',
          component: Aboutus,
          meta:{ title:'About Us', bgcolor:'#fff'}
        },{
          path:"help",
          name:'help',
          component: Help,
          meta:{ title:'Help', bgcolor:'#fff'}
        }
      ]
    },{
      path:"/download",
      name:'Download',
      component: Download,
      meta:{ title:'Download', bgcolor:'#fff'}
    },{
      path:"/alert",
      name:'Alert',
      component: Alert,
      meta:{ title:'Alert', bgcolor:'#fff'}
    },{
      path:"/distribution",
      name:'Distribution',
      component: Distribution,
      meta:{ title:'Distribution', bgcolor:'#fff'}
    }
]
const router  = createRouter({
    history: createWebHistory('/'),
    routes
})
const whiteList = ['/promotion/register','/login', '/download', '/alert', '/verify/contact2', '/orders/audit', '/joint', "/distribution", '/protocol/term','/protocol/privacy']
router.beforeEach((to, from, next) => {
    document.title = to.meta.title ? to.meta.title : 'Index'    
    document.body.style.background = to.meta.bgcolor ? to.meta.bgcolor : '#fff'  
    document.body.parentElement.scrollTop = 0
    const hasToken = getToken() || getTokenFromStorage()   
    // alert(hasToken)   
    if (hasToken) {
      if (to.path === '/login') {        
        // next({ path: '/' })        
        next()
      } else {
        next()
      }
        
    } else {
      if (whiteList.indexOf(to.path) !== -1) {     
        next()        
      } else {
        let queryString = ""
        for(let x in to.query) {
          let content = to.query[x]
          if(x == 'adjust_referrer') {
            queryString += `&adjust_reftag=${content.replace("adjust_reftag=","")}`                
          } else {
            queryString += `&${x}=${content}`
          }              
        }       
        next(`/login?redirect=${to.path}${queryString}`)
        // NProgress.done()
      }
    }
  })
export default router